import { BLOG_YAZILARI, type BlogYazisi } from "./blog_data";

/** Yazının altında gösterilecek ilgili yazılar: önce aynı kategori, sonra en yeniler. */
export function ilgiliYazilar(slug: string, adet = 3): BlogYazisi[] {
  const yazi = BLOG_YAZILARI.find(y => y.slug === slug);
  if (!yazi) return [];
  const digerleri = BLOG_YAZILARI.filter(y => y.slug !== slug).sort((a, b) => b.isoDate.localeCompare(a.isoDate));
  const ayni = digerleri.filter(y => y.category === yazi.category);
  const kalan = digerleri.filter(y => y.category !== yazi.category);
  return [...ayni, ...kalan].slice(0, adet);
}
